import { useState, useEffect } from 'react';

export default function OfflineToast() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      background: 'var(--color-text, #1a1a1a)', color: '#fff',
      padding: '10px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600,
      zIndex: 9999, boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-red, #ef4444)', flexShrink: 0 }} />
      You're offline — changes won't be saved until you reconnect
    </div>
  );
}
